/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, ReactElement } from 'react';
import { useGateway } from '../hooks';
import GatewayContextType from './GatewayContextType';

const GatewayContext = createContext<GatewayContextType>({
  gatewayUrl: '',
  getAuthToken: () => '',
  canUseGatewayApi: false
});

interface GatewayProviderProps {
  children: ReactElement;
  gatewayUrl?: string;
  getAuthToken?: () => string;
}

export const GatewayProvider = (props: GatewayProviderProps) => {
  const gatewayMethods = useGateway({ gatewayUrl: props.gatewayUrl, getAuthToken: props.getAuthToken });
  return <GatewayContext.Provider value={gatewayMethods}>{props.children}</GatewayContext.Provider>;
};

export default GatewayContext;
